import React from 'react';

import { Box } from '@mui/material';

import AssetFieldCell from './AssetFieldCell';

export interface AssetField {
  label: string;
  value?: React.ReactNode;
  href?: string;
  checkbox?: boolean | null;
}

interface Props {
  left: Array<AssetField>;
  right: Array<AssetField>;
}

export default function AssetFieldGrid({ left, right }: Props) {
  const rowCount = Math.max(left.length, right.length);
  const rows = Array.from({ length: rowCount }, (_, index) => ({ left: left[index], right: right[index] }));

  return (
    <>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: '5fr 7fr', columnGap: 4 }}>
          {left.map((field) => (
            <AssetFieldCell key={field.label} {...field} />
          ))}
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: '5fr 7fr', columnGap: 4, mt: 2 }}>
          {right.map((field) => (
            <AssetFieldCell key={field.label} {...field} />
          ))}
        </Box>
      </Box>
      <Box sx={{ display: { xs: 'none', md: 'grid' }, gridTemplateColumns: '5fr 7fr 5fr 7fr', columnGap: 4 }}>
        {rows.map((row, index) => (
          <React.Fragment key={index}>
            {row.left ? <AssetFieldCell {...row.left} /> : <Box sx={{ gridColumn: 'span 2' }} />}
            {row.right ? <AssetFieldCell {...row.right} /> : <Box sx={{ gridColumn: 'span 2' }} />}
          </React.Fragment>
        ))}
      </Box>
    </>
  );
}
